const ERROR_MESSAGES = {
  EMAIL_VERIFICATION_TOKEN_EXPIRED: "Token has expired.",
  SEND_VERIFICATION_EMAIL_LIMIT_EXCEEDED:
    "Please wait to resend email verification link.",
};

export default ERROR_MESSAGES;
